import React, { Component } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from "swiper";

import "swiper/css"; // swiper 기본 css 혹은  scss
import "swiper/css/pagination"; // swiper 기본 css 혹은  scss

import './Swiper1.css'; // 내가 작업한 css 혹은  scss

const Slide = () => {
  return (
    <div className="banner">
      <Swiper
        modules={[Pagination, Autoplay]}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        className=""
      >
        <SwiperSlide>
        <div class="swiper-slide" id="img1">
            <img src="images/main1.jpg" alt="메인배너1" />
              <div class="blackbox">
              <h2>이색적인 실내 데이트</h2>
              <h3>BEST 5</h3>
              <p>사람들이 자주 찾는 실내 데이트를<br />한 눈에 알아보세요!</p>
              <div class="view"><a href="#">더보기</a></div>
            </div>
            </div>
        </SwiperSlide>
        <SwiperSlide><div class="swiper-slide" id="img2">
            <img src="images/main2.jpg" alt="메인배너1" />
              <div class="blackbox">
                <h2>걷기 좋은 야외데이트</h2>
                <h3>BEST 5</h3>
                <p>사람들이 자주 찾는 야외 데이트를<br />한 눈에 알아보세요!</p>
                <div class="view"><a href="#">더보기</a></div>
              </div>
            </div></SwiperSlide>
        <SwiperSlide>   
          <div class="swiper-slide" id="img3">
          <img src="images/main3.jpg" alt="메인배너1" />
              <div class="blackbox">
                <h2>인생샷 건지러가자!</h2>
                <h3>BEST 5</h3>
                <p>완벽한 하루에서 엄선한 사진명소를<br />한 눈에 알아보세요!</p>
                <div class="view"><a href="#">더보기</a></div>
              </div>
            </div>
         
          </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Slide;
